import React, { useState } from "react";
import { Input } from "antd";
import { Search } from "lucide-react";

function SearchBar({ placeholder, searchHandler, filters, pagination }) {
  const [value, setValue] = useState("");

  const onSearchHandler = (val) => {
      searchHandler({
          ...filters,
          page: 1,
          paginate: pagination?.per_page || 10,
          keyword: val,
      });
  };

  return (
    <div className="w-full">
        <div className="relative items-center flex h-9 rounded-md border py-1 text-base
                        md:text-sm focus-within:border-gray-500 focus-within:ring-gray-500/50
                        focus-within:ring-2 focus-within:outline-none border-purple-200 
                        focus:border-purple-400"
        >
            <Search className="absolute left-3 text-gray-400 w-4 h-4" />
            <Input
                placeholder={placeholder ?? "Keyword"}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onPressEnter={() => onSearchHandler(value)}
                allowClear
                variant="borderless"
                className="
                    pl-9 sm:pl-10
                    pr-3
                    text-[13px] sm:text-[14px]
                    placeholder:text-muted-foreground
                    disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
                    bg-transparent
                "
            />
        </div>
    </div>
  );
}

export default SearchBar;
